import type { Settings } from '@brighterly/lib-core-types/customer/interfaces'
import type { SettingsStore } from './interfaces'

export const getters = {
  hasData: (state: SettingsStore): boolean => !!state.settings,
  isInitialLoaded: (state: SettingsStore): boolean => state._initialLoaded,
  getAnswers: (state: SettingsStore): Settings['answers'] => state.settings?.answers || [],
  isViewedMetaMessenger: (state: SettingsStore): boolean => !!state.settings?.viewed_meta_messenger,
  isShowGuideModal: (state: SettingsStore): boolean => !!state.settings?.show_guide_modal,
  isViewedAiSummaryFeedback: (state: SettingsStore): boolean => !!state.settings?.viewed_ai_summary_feedback,
  isShowNewReferralProgram: (state: SettingsStore): boolean => !!state.settings?.show_new_referral_program,
  isShowNewReferralCredits: (state: SettingsStore): boolean => !!state.settings?.show_new_referral_credits,
}
